import {
	ConsoleInstrumentation,
	ErrorsInstrumentation,
	LogLevel,
	NavigationInstrumentation,
	SessionInstrumentation,
	ViewInstrumentation,
	WebVitalsInstrumentation,
	faro,
	initializeFaro
} from '@grafana/faro-web-sdk';

import { sanitizeFaroTransportItem } from './faro-before-send.util';
import { FaroEnvironmentConfig } from './faro.interfaces';

/**
 * Initializes Grafana Faro when enabled in the active environment configuration.
 *
 * @param {FaroEnvironmentConfig | undefined} faroConfig - Faro settings from environment.
 * @param {string} appVersion - Application version string sent with telemetry.
 * @return {void} No return value.
 */
export function initializeFaroFromEnvironment(faroConfig: FaroEnvironmentConfig | undefined, appVersion: string): void {
	if (!faroConfig?.enabled || !faroConfig.collectorUrl) {
		return;
	}

	initializeFaro({
		url: faroConfig.collectorUrl,
		apiKey: faroConfig.apiKey,
		app: {
			name: 'somerville-req-app',
			version: appVersion,
			environment: faroConfig.appEnvironment
		},
		beforeSend: sanitizeFaroTransportItem,
		ignoreUrls: [/faro\/collect/i, /auth\/refresh-token/i],
		consoleInstrumentation: {
			disabledLevels: [LogLevel.TRACE, LogLevel.DEBUG, LogLevel.INFO, LogLevel.LOG],
			consoleErrorAsLog: true
		},
		instrumentations: [
			new ErrorsInstrumentation(),
			new ConsoleInstrumentation(),
			new WebVitalsInstrumentation(),
			new SessionInstrumentation(),
			new ViewInstrumentation(),
			new NavigationInstrumentation()
		]
	});
}

/**
 * Returns whether the Faro client has been initialized in this browser session.
 *
 * @return {boolean} True when Faro API is available.
 */
export function isFaroInitialized(): boolean {
	return Boolean(faro.api);
}
